const actionTypes = {
  STATION_LIST_ACTION: 'STATION_LIST_ACTION',
  ACTIVE_STATION_ACTION: 'ACTIVE_STATION_ACTION',
  LIGHTBOX_ACTION: 'LIGHTBOX_ACTION',
  MAP_ACTION: 'MAP_ACTION',
  TYRE_ACTION: 'TYRE_ACTION',
  VEHICLE_SELECTOR_ACTION: 'VEHICLE_SELECTOR_ACTION',
  TRANSLATION_ACTION: 'TRANSLATION_ACTION',
  CONFIGURATOR_ACTION: 'CONFIGURATOR_ACTION',
  POSTCODE_ACTION: 'POSTCODE_ACTION',
  CATALOG_FILTER_ACTION: 'CATALOG_FILTER_ACTION',
  CART_ACTION: 'CART_ACTION',
  CATALOG_CONFIGURATOR_ACTION: 'CATALOG_CONFIGURATOR_ACTION',
  VEHICLE_CONFIGURATOR_ACTION: 'VEHICLE_CONFIGURATOR_ACTION',
  VEHICLE_DETAILS_ACTION: 'VEHICLE_DETAILS_ACTION',
  REGO_LOOKUP_ACTION: 'REGO_LOOKUP_ACTION',
  FILTER_OPTIONS_ACTION: 'FILTER_OPTIONS_ACTION',
  TYRE_SIZE_CONFIGURATOR_FILTER_OPTIONS_ACTION: 'TYRE_SIZE_CONFIGURATOR_FILTER_OPTIONS_ACTION',
  TYRE_MOTO_SIZE_CONFIGURATOR_FILTER_OPTIONS_ACTION: 'TYRE_MOTO_SIZE_CONFIGURATOR_FILTER_OPTIONS_ACTION',
  CATALOG_ITEMS_ACTION: 'CATALOG_ITEMS_ACTION',
  NOTIFY_ME_ACTION: 'NOTIFY_ME_ACTION',
  CATALOG_FILTER_VIEW_ACTION: 'CATALOG_FILTER_VIEW_ACTION',
  CATALOG_CONDITIONAL_OPTIONS_ACTION: 'CATALOG_CONDITIONAL_OPTIONS_ACTION',
  CATALOG_MOBILE_FILTER_VISIBILITY_ACTION: 'CATALOG_MOBILE_FILTER_VISIBILITY_ACTION',
  CATALOG_FILTER_EXPLICIT_IMPLICIT_APPLY: 'CATALOG_FILTER_EXPLICIT_IMPLICIT_APPLY',
  CATALOG_FILTER_PROVISIONAL_STATE: 'CATALOG_FILTER_PROVISIONAL_STATE',
  CATALOG_FILTER_LIGHTBOX_VIEW_ACTION: 'CATALOG_FILTER_LIGHTBOX_VIEW_ACTION',
  CATALOG_SORTING_ACTION: 'CATALOG_SORTING_ACTION',
  CATALOG_PROMOTIONS_ACTION: 'CATALOG_PROMOTIONS_ACTION',
  CATALOG_ADS_ACTION: 'CATALOG_ADS_ACTION',
  CATALOG_POSTCODE_ACTION: 'CATALOG_POSTCODE_ACTION',
  CATALOG_DELIVERY_INFO_LIGHT_BOX_ACTION: 'CATALOG_DELIVERY_INFO_LIGHT_BOX_ACTION',
  INFO_LIGHT_BOX_ACTION: 'INFO_LIGHT_BOX_ACTION',
  FILTER_AVAILBALE_OPTIONS_ACTION: 'FILTER_AVAILBALE_OPTIONS_ACTION',
  CATALOG_SHOW_DETAILS_ACTION: 'CATALOG_SHOW_DETAILS_ACTION',
  UI_LOCK_ACTION: 'UI_LOCK_ACTION',
  LIGHTBOX_UI_LOCK_ACTION: 'LIGHTBOX_UI_LOCK_ACTION',
  TYRE_INDEX_EXPLANATION_LIGHTBOX_ACTION: 'TYRE_INDEX_EXPLANATION_LIGHTBOX_ACTION',
  WHERE_TO_FIND_TYRE_SIZE_LIGHT_BOX_ACTION: 'WHERE_TO_FIND_TYRE_SIZE_LIGHT_BOX_ACTION',
  CONTACT_US_LIGHT_BOX_ACTION: 'CONTACT_US_LIGHT_BOX_ACTION',
  FSF_MOTO_LIGHTBOX_ACTION: 'FSF_MOTO_LIGHTBOX_ACTION',
  FSF_NOT_AVAILABLE_LIGHTBOX_ACTION: 'FSF_NOT_AVAILABLE_LIGHTBOX_ACTION',
  INFO_POPUP_ACTION: 'INFO_POPUP_ACTION',
  FS_HOME_PAGE_LIGHTBOX_ACTION: 'FS_HOME_PAGE_LIGHTBOX_ACTION',
  SELECT_FS_LIGHTBOX_ACTION: 'SELECT_FS_LIGHTBOX_ACTION',
  FS_REMOVE_LIGHTBOX_ACTION: 'FS_REMOVE_LIGHTBOX_ACTION',
  CROSS_SELL_REMOVE_LIGHTBOX_ACTION: 'CROSS_SELL_REMOVE_LIGHTBOX_ACTION',
  VOUCHER_CODE_LIGHTBOX_ACTION: 'VOUCHER_CODE_LIGHTBOX_ACTION',
  CROSS_SELL_LIGHTBOX_ACTION: 'CROSS_SELL_LIGHTBOX_ACTION',
  VEHICLE_DETAILS_LIGHTBOX_ACTION: 'VEHICLE_DETAILS_LIGHTBOX_ACTION',
  DRIVER_REVIEW_LIGHTBOX_ACTION: 'DRIVER_REVIEW_LIGHTBOX_ACTION',
  IMAGE_LIGHTBOX_ACTION: 'IMAGE_LIGHTBOX_ACTION',
  WHEEL_ALIGNMENT_INFO_LIGHTBOX_ACTION: 'WHEEL_ALIGNMENT_INFO_LIGHTBOX_ACTION',
  PAYPAL_CREDIT_CARD_FORM_ACTION: 'PAYPAL_CREDIT_CARD_FORM_ACTION',
  PRODUCTS_ACTION: 'PRODUCTS_ACTION',
  CROSS_SELL_PRODUCTS_ACTION: 'CROSS_SELL_PRODUCTS_ACTION',
  POSTCODE_LIGHT_BOX_ACTION: 'POSTCODE_LIGHT_BOX_ACTION',
  FRIENDBUY_LIGHT_BOX_ACTION: 'FRIENDBUY_LIGHT_BOX_ACTION',
  FREE_MOBILE_FITTING_LIGHT_BOX_ACTION: 'FREE_MOBILE_FITTING_LIGHT_BOX_ACTION',
  CUSTOMER_REDIRECT_LIGHT_BOX_ACTION: 'CUSTOMER_REDIRECT_LIGHT_BOX_ACTION',
  SIDEBAR_ACTION: 'SIDEBAR_ACTION',
  ORDER_TRACKING_SHOW_ADDRESS_FORM_ACTION: 'ORDER_TRACKING_SHOW_ADDRESS_FORM_ACTION',
  LAST_USED_CONFIGURATOR: 'LAST_USED_CONFIGURATOR',
  SHIPPING_ACTION: 'SHIPPING_ACTION',
  HTTP_REQUEST_ACTION: 'HTTP_REQUEST_ACTION',
  PRODUCT_BATCH_STOCKS_ACTION: 'PRODUCT_BATCH_STOCKS_ACTION',
  PRODUCT_MIXED_STOCKS_COMPUTE_ACTION: 'PRODUCT_MIXED_STOCKS_COMPUTE_ACTION',
  PRODUCT_MIXED_STOCKS_LIGHTBOX_ACTION: 'PRODUCT_MIXED_STOCKS_LIGHTBOX_ACTION',
  ACTIVE_PRODUCT_ACTION: 'ACTIVE_PRODUCT_ACTION',
  BILLING_ADDRESS_ACTION: 'BILLING_ADDRESS_ACTION',
  SHIPPING_ADDRESS_ACTION: 'SHIPPING_ADDRESS_ACTION',
  CMS_LIGHTBOX_ACTION: 'CMS_LIGHTBOX_ACTION',
  FS_APPOINTMENT_ACTION: 'FS_APPOINTMENT_ACTION',
  FS_APPOINTMENT_DETAILS_ACTION: 'FS_APPOINTMENT_DETAILS_ACTION',
  SERVICES_FORM_ACTION: 'SERVICES_FORM_ACTION',
  OLA_HOME_PAGE_LIGHTBOX_ACTION: 'OLA_HOME_PAGE_LIGHTBOX_ACTION',
};

export default actionTypes;
export { actionTypes };
